import './SearchBar.scss';
import { observer } from 'mobx-react-lite';
import {
  TextField,
  IconButton,
  InputAdornment,
} from '@mui/material';
import { ReactComponent as ClearIcon } from 'images/icons/Close.svg';
import { useStores } from 'index';
import { ToolBar } from '../ToolBar/ToolBar';

export const SearchBar = observer(() => {
  const {
    searchQuery,
    setSearchQuery,
  } = useStores().mediaLibraryStore;

  return (
    <div className="file-manager-toolbar">
      <TextField
        size="small"
        variant="outlined"
        placeholder="Search"
        value={searchQuery}
        onChange={e => setSearchQuery(e.target.value)}
        className="file-manager-toolbar__search"
        InputProps={searchQuery ?{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton size="small" onClick={() => setSearchQuery('')}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        } : {}}
      />

      <ToolBar />
    </div>
  );
});